import { Action } from '../../common/actions/core/action';
import { CancelSubscriptionType, PackageThumbnail } from '../../common/services/package/package.model';
import { ApplyChurnSuccessResponse } from '../../common/services/package/package.model';

export class ChurnRetentionAction implements Action {
  constructor(
    public onDeleteSuccess: (type: CancelSubscriptionType) => void,
    public onChurnSuccess: (messageObj: ApplyChurnSuccessResponse) => void,
    public packet: PackageThumbnail,
    public price: string,
    public discountRate: string,
    public discountedPrice: string,
    public discountedRenewalCount: string,
    public msisdnTr?: string,
    public masterCardName?: string
  ) {}
}



// WEBPACK FOOTER //
// src/app/buy/churn-retention-dialog/churn-retention-dialog.action.ts